export enum CustomerIdentityKeyEnum {
    AnyOne = 0,
    Email = 1,
    ContactNumber = 2,
    Both = 3,
}

export enum ProductIdentityKeyEnum {
    Both = 0,
    SKU = 1,
    Name = 2
}

export const enum OrderPriceBasedOnEnum {
    SellingChannelPrice = 0,
    SKDSalePrice = 1
}

export enum LabelPrintingIdentityKeyEnum {
    Both = 0,
    SKU = 1,
    Name = 2,
}

export enum ShippingOnFairAndEstimatedDays {
    Fair = 1,
    EstimatedDays = 2,
}

export enum ProductStatusIdentityKeyEnum {
    Active = 1,
    Draft = 2,
    All = 3
}
